<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createMegaConfig } from "./fs";
  import { makeFileSystemMega, megaLogin } from "./fs-mega";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createMegaConfig());
  let password = $state("");
  let code = $state("");
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.email.trim() != "" && password != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("logging in to Mega");
    try {
      config.email = config.email.trim();
      let res = await megaLogin(config.email, password, code.trim());
      config.sid = res.sid;
      config.key = res.key;
      config.name = config.name.trim() || config.email;
      let fs = makeFileSystemMega(config);
      telegramNotify(`New Mega connection for ${config.email}`);
      captureEvent("mega-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Mega">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-mega-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-mega-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-mega-email">Email:</label>
      <input
        type="text"
        id="input-mega-email"
        autocomplete="username"
        class="outline-hidden border px-2 py-1"
        bind:value={config.email}
      />

      <label class="mt-3" for="input-mega-password">Password:</label>
      <input
        type="password"
        id="input-mega-password"
        autocomplete="current-password"
        class="outline-hidden border px-2 py-1"
        bind:value={password}
      />

      <label class="mt-3" for="input-mega-code"
        >Two-factor code: <span class="text-gray-400">(if the account uses one)</span></label
      >
      <input
        type="text"
        id="input-mega-code"
        inputmode="numeric"
        autocomplete="one-time-code"
        class="outline-hidden border px-2 py-1"
        bind:value={code}
      />

      <div class="mt-3 w-72 text-gray-500">
        Mega encrypts files with your account's keys, so the Sumatra File Manager Online server logs in for you and
        encrypts and decrypts your files. The password is not kept. Sumatra File Manager Online keeps the session and
        the account key in this browser.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Mega</button>
    </div>
  {/snippet}
</DialogBase>
